import * as React from 'react';
import { MainPage } from 'client/respondent/shared/pages/main-page';
import { RequestResetPasswordContainer } from '../../../containers/access/reset-password/request-reset';

export const RequestResetPasswordPage: React.FC = () => {
  return <MainPage>{() => <RequestResetPasswordContainer />}</MainPage>;
};
RequestResetPasswordPage.displayName = 'RequestResetPasswordPage';
